import React from 'react';
import MainTemplate from 'pages/templates/MainTemplate';

import MainContentTemplate from '../../../templates/MainContentTemplate';
import Statistics from './Statistics';

const Status = () => {
  return (
    <MainTemplate className="mb-User">
      <MainContentTemplate>
        <Statistics />
      </MainContentTemplate>
    </MainTemplate>
  );
};

export default Status;
